import axios from 'axios';
import { isNeibu } from '../utils';

const env = isNeibu() ? 'neibu.' : '';

export const getNavMenu = () => {
    return axios.get(`//m-kaoyan.${env}koolearn.com/api/v1/index/menu-links`).then((res) => {
        if (res.status === 200 && res.data.code === 0) {
            return res.data;
        }
    });
};

export const getInterestLabel = () => {
    return $.ajax({
        method: 'get',
        dataType: 'jsonp',
        url: `//i.${env}koolearn.com/productClass/productClassList?parentId=33`,
    });
};

export const saveInterestLabel = (data) => {
    return axios.post(`//tong.${env}koolearn.com/interestTag/v1/save`, data).then((res) => {
        if (res.status === 200) {
            return res.data;
        }
    });
};
